import { render, staticRenderFns } from "./addtocatalog-products.vue?vue&type=template&id=1cda934a&scoped=true&"
import script from "./addtocatalog-products.vue?vue&type=script&lang=js&"
export * from "./addtocatalog-products.vue?vue&type=script&lang=js&"
import style0 from "./addtocatalog-products.vue?vue&type=style&index=0&id=1cda934a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda934a",
  null
  
)

export default component.exports